import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import moment from 'moment';
import { registerLocale } from 'react-datepicker';
import { es } from 'date-fns/locale/es';
import { it } from 'date-fns/locale/it';
import { EXPORT_LIMIT } from 'web-shared/modules/FilesProccessing/const';
import { LOCALE_KEY } from '../../consts/languages';
import enTranslation from './locales/en.json';
import { lazyLoad } from './plugins/lazy-load';

import 'moment/locale/it';
import 'moment/locale/es';
import 'moment/locale/es-mx';

registerLocale('es', es);
registerLocale('es-mx', es);
registerLocale('it', it);

moment.locale(LOCALE_KEY.ENGLISH);

i18n
  .use(initReactI18next)
  .use(lazyLoad)
  .init({
    showSupportNotice: false,
    resources: {
      [LOCALE_KEY.ENGLISH]: {
        translation: enTranslation
      },
    },
    lng: LOCALE_KEY.ENGLISH,
    fallbackLng: LOCALE_KEY.ENGLISH,
    backend: {
      loadPath: '/locales/{{lng}}.json'
    },
    partialBundledLanguages: true,
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}',
      defaultVariables: {
        exportLimit: EXPORT_LIMIT.toLocaleString()
      }
    },
  });
